// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GetMcqStudentQuestionsParams,
  HTTPValidationError,
  MCQAnswerUpdateRequest,
  MCQAnswerUpdateResponse,
  MCQAttemptRequest,
  MCQAttemptResponse,
  MCQStudentQuestion,
  PersistMcqAnswerParams,
  ResetMcqAttemptParams,
  SubmitMcqAttemptParams,
} from '../../models';

/**
 * Get MCQ questions for student (shuffled, without correct answers).
 * @summary Get Mcq Questions
 */
export const getMcqStudentQuestions = (
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQStudentQuestion[]>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/mcq/questions`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetMcqStudentQuestionsQueryKey = (
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
) => {
  return [
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/mcq/questions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMcqStudentQuestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMcqStudentQuestions>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMcqStudentQuestionsQueryKey(courseId, moduleId, taskId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMcqStudentQuestions>>> = ({ signal }) =>
    getMcqStudentQuestions(courseId, moduleId, taskId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMcqStudentQuestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMcqStudentQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMcqStudentQuestions>>>;
export type GetMcqStudentQuestionsQueryError = AxiosError<HTTPValidationError>;

export function useGetMcqStudentQuestions<
  TData = Awaited<ReturnType<typeof getMcqStudentQuestions>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMcqStudentQuestions<
  TData = Awaited<ReturnType<typeof getMcqStudentQuestions>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMcqStudentQuestions<
  TData = Awaited<ReturnType<typeof getMcqStudentQuestions>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Mcq Questions
 */

export function useGetMcqStudentQuestions<
  TData = Awaited<ReturnType<typeof getMcqStudentQuestions>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  params: GetMcqStudentQuestionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMcqStudentQuestions>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMcqStudentQuestionsQueryOptions(courseId, moduleId, taskId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit an MCQ attempt and update task submission state.
 * @summary Submit Mcq Attempt
 */
export const submitMcqAttempt = (
  courseId: string,
  moduleId: string,
  taskId: string,
  mCQAttemptRequest: MCQAttemptRequest,
  params: SubmitMcqAttemptParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQAttemptResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/mcq/submit`, mCQAttemptRequest, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSubmitMcqAttemptMutationOptions = <
  TData = Awaited<ReturnType<typeof submitMcqAttempt>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: MCQAttemptRequest; params: SubmitMcqAttemptParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['submitMcqAttempt'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitMcqAttempt>>,
    { courseId: string; moduleId: string; taskId: string; data: MCQAttemptRequest; params: SubmitMcqAttemptParams }
  > = (props) => {
    const { courseId, moduleId, taskId, data, params } = props ?? {};

    return submitMcqAttempt(courseId, moduleId, taskId, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: MCQAttemptRequest; params: SubmitMcqAttemptParams },
    TContext
  >;
};

export type SubmitMcqAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof submitMcqAttempt>>>;
export type SubmitMcqAttemptMutationBody = MCQAttemptRequest;
export type SubmitMcqAttemptMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Submit Mcq Attempt
 */
export const useSubmitMcqAttempt = <
  TData = Awaited<ReturnType<typeof submitMcqAttempt>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: MCQAttemptRequest; params: SubmitMcqAttemptParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: MCQAttemptRequest; params: SubmitMcqAttemptParams },
  TContext
> => {
  const mutationOptions = getSubmitMcqAttemptMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Persist one in-progress MCQ selection for proctored-safe recovery.

Exam gating violations are mapped to HTTP 403 with stable detail codes.
 * @summary Persist Mcq Answer
 */
export const persistMcqAnswer = (
  courseId: string,
  moduleId: string,
  taskId: string,
  mCQAnswerUpdateRequest: MCQAnswerUpdateRequest,
  params: PersistMcqAnswerParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQAnswerUpdateResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/mcq/answer`, mCQAnswerUpdateRequest, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getPersistMcqAnswerMutationOptions = <
  TData = Awaited<ReturnType<typeof persistMcqAnswer>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      data: MCQAnswerUpdateRequest;
      params: PersistMcqAnswerParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['persistMcqAnswer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof persistMcqAnswer>>,
    { courseId: string; moduleId: string; taskId: string; data: MCQAnswerUpdateRequest; params: PersistMcqAnswerParams }
  > = (props) => {
    const { courseId, moduleId, taskId, data, params } = props ?? {};

    return persistMcqAnswer(courseId, moduleId, taskId, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      data: MCQAnswerUpdateRequest;
      params: PersistMcqAnswerParams;
    },
    TContext
  >;
};

export type PersistMcqAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof persistMcqAnswer>>>;
export type PersistMcqAnswerMutationBody = MCQAnswerUpdateRequest;
export type PersistMcqAnswerMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Persist Mcq Answer
 */
export const usePersistMcqAnswer = <
  TData = Awaited<ReturnType<typeof persistMcqAnswer>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      data: MCQAnswerUpdateRequest;
      params: PersistMcqAnswerParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: MCQAnswerUpdateRequest; params: PersistMcqAnswerParams },
  TContext
> => {
  const mutationOptions = getPersistMcqAnswerMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete existing MCQ answers and attempts for a clean retry.
 * @summary Reset Mcq Attempt
 */
export const resetMcqAttempt = (
  courseId: string,
  moduleId: string,
  taskId: string,
  params: ResetMcqAttemptParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/mcq/attempt`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getResetMcqAttemptMutationOptions = <
  TData = Awaited<ReturnType<typeof resetMcqAttempt>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; params: ResetMcqAttemptParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['resetMcqAttempt'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetMcqAttempt>>,
    { courseId: string; moduleId: string; taskId: string; params: ResetMcqAttemptParams }
  > = (props) => {
    const { courseId, moduleId, taskId, params } = props ?? {};

    return resetMcqAttempt(courseId, moduleId, taskId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; params: ResetMcqAttemptParams },
    TContext
  >;
};

export type ResetMcqAttemptMutationResult = NonNullable<Awaited<ReturnType<typeof resetMcqAttempt>>>;

export type ResetMcqAttemptMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reset Mcq Attempt
 */
export const useResetMcqAttempt = <
  TData = Awaited<ReturnType<typeof resetMcqAttempt>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; params: ResetMcqAttemptParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; params: ResetMcqAttemptParams },
  TContext
> => {
  const mutationOptions = getResetMcqAttemptMutationOptions(options);

  return useMutation(mutationOptions);
};
